import { useEffect, useState } from "react"
import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, Grid, Toolbar, Typography } from "@mui/material"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useLayoutExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Transition } from "../../../../../../components"

export const DeleteLayoutForm = () => {
    // State
    const { openDeleteLayout, layoutSelecionado } = useAppSelector((state) => state.layoutExtracao)
    // useState
    const [loading, setLoading] = useState<boolean>(true)
    // Hook
    const { setOpenDeleteLayout, deleteLayout, resetLayoutSelecionado } = useLayoutExtracaoService()
    // Function
    const closeDialog = () => {
        resetLayoutSelecionado()
        setOpenDeleteLayout(false)
    }
    // useEffect
    useEffect(() => {
        setLoading(false)
    }, [])

    return (
        <>
            {
                loading ? <></>
                    : <Dialog
                        maxWidth="sm"
                        TransitionComponent={Transition}
                        open={openDeleteLayout}
                        onClose={closeDialog}
                    >
                        <AppBar sx={{ position: 'relative' }}>
                            <Toolbar>
                                <Typography
                                    textAlign="center"
                                    sx={{ ml: 2, flex: 1 }}
                                    textTransform="uppercase"
                                    fontWeight="bold"
                                    variant="h6"
                                    component="div"
                                >
                                    Excluir
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <DialogContent dividers>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 2 }}>
                                <Typography
                                    variant="body1"
                                    textTransform="uppercase"
                                    textAlign={'center'}
                                    fontWeight="bold"
                                >
                                    Tem certeza que deseja excluir este layout?
                                </Typography>
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                            <Grid container spacing={2} justifyContent="center" alignItems="center">
                                <Grid item xs={6}>
                                    <Button
                                        fullWidth
                                        autoFocus
                                        variant="outlined"
                                        onClick={closeDialog}
                                    >
                                        Cancelar
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                            if (layoutSelecionado) {
                                                deleteLayout(layoutSelecionado.IdVelesGeoLayoutExtracao)
                                                setOpenDeleteLayout(false)
                                                resetLayoutSelecionado()
                                            }
                                        }}
                                    >
                                        Excluir
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </Dialog>

            }
        </>
    )
}